export function formatDateToString(date: Date): string {
  const year = date.getFullYear();
  const month = ('0' + (date.getMonth() + 1)).slice(-2);
  const day = ('0' + date.getDate()).slice(-2);
  return `${year}-${month}-${day}`;
}

export function getDOBFromID(Id: string): Date {
  const yy = Id.substring(0, 2);
  const mm = Id.substring(2, 4);
  const dd = Id.substring(4, 6);

  // Convert 2-digit year to 4-digit year
  const currentYear = new Date().getFullYear();
  const currentCentury = Math.floor(currentYear / 100) * 100;
  const currentYearInCentury = currentYear % 100;

  let fullYear: number;
  const year = parseInt(yy);

  // If the year is greater than current year in century, it's from previous century
  if (year > currentYearInCentury) {
    fullYear = currentCentury - 100 + year;
  } else {
    fullYear = currentCentury + year;
  }

  // Create date in YYYY-MM-DD format
  const dateString = `${fullYear}-${mm}-${dd}`;
  const dob = new Date(dateString);

  return dob;
}
